import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Import background images
import bg1 from "../assets/images/giaodienmini_game_tet_2026/01. Background landingpage/1.png";
import bg1b from "../assets/images/giaodienmini_game_tet_2026/01. Background landingpage/1b.png";
import bg3 from "../assets/images/giaodienmini_game_tet_2026/01. Background landingpage/3.png";
import bg2 from "../assets/images/giaodienmini_game_tet_2026/01. Background landingpage/2.png";

// Import footage/icons
import chuDe from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/00 Chu de.png";
import binhTuoiCay from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/01 Binh tuoi cay.png";
import chiSoLanToa from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/02 Chi so lan toa.png";
import chiSoChamChi from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/03 Chi so cham chi.png";
import bangXepHang from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/04 Bang xep hang.png";
import boSuuTap from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/05 Bo Suu tap.png";
import diemDanh from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/06 Diem danh.png";
import Facebook from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/Facebook.png";
import cayTaiLoc from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/Cay-gia-toc-HungHau.png";
import cayGiaToc from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/08 Cay gia toc Hung Hau.png";
import Buttontuoicay from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/Button tuoi cay.png";
import ButtonLuottuoi from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/Button luot tuoi.png";
import submitPopup from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/submitPopup.png";

// popup reward
import PopUpHvang from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/1Popup chuc mung H vang.png";
import PopUpHbac from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/1Popup chuc mung H bac.png";
import PopUpHdong from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/1Popup chuc mung-dong.png";

// import Buttontuoicay from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/10 LI xi H+.png";
import frameTop from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/11 Frame top.png";
import sidebar from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/208sidebar.png";
import sidebar2 from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/Side-bar2.png";
import image from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/image4.png";
import Top3FarmThu from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/Top3FarmThu.png";
import HH1 from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/HH1.png";
import HH2 from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/HH2.png";
import HH3 from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/HH3.png";
import bangxephanglantoa from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/bangxephanglantoa.png";
import bangxephangmyucoin from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/bangxephangmyucoin.png";
import developedBy from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/developedBy.png";
import POPUPCheckingif from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/POPUP-Checkin-gif.gif";
import POPUPFacebookgif from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/POPUP-facebook-gif.gif";
import validateFBLink from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/validateFBLink.png";
import Loichuc from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/Loichuc.png";
import Linkdasudung from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/Linkdasudung.png";
import Popuptangluottuoi from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/Popup tang luot tuoi.png";
import Top01 from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/Top 01.png";
import Top02 from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/Top 02.png";
import Top03 from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/Top 03.png";

import NhacNenTet2026 from "../assets/images/NhacNenTet2026.mp3";
// import sidebar from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/208sidebar.png";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import Title from "../components/UI/title.js";
import Frame from "../components/UI/frame.js";
import Boxtitle from "../components/Boxtitle.js";
import Checkbox from "../components/UI/Checkbox.js";
import { mission, treePlanting, userEvent } from "../controller";
import Noti from "../components/Noti";
import Farmthu from "../components/UI/Farmthu.js";
import { FaTrophy, FaMedal, FaStar } from "react-icons/fa";

// Array điểm danh từ 13/2/2026 đến 24/2/2026
const initialAttendance = [
  { date: "13/02/2026", day: 13, month: 2, checked: false },
  { date: "14/02/2026", day: 14, month: 2, checked: false },
  { date: "15/02/2026", day: 15, month: 2, checked: false },
  { date: "16/02/2026", day: 16, month: 2, checked: false },
  { date: "17/02/2026", day: 17, month: 2, checked: false },
  { date: "18/02/2026", day: 18, month: 2, checked: false },
  { date: "19/02/2026", day: 19, month: 2, checked: false },
  { date: "20/02/2026", day: 20, month: 2, checked: false },
  { date: "21/02/2026", day: 21, month: 2, checked: false },
  { date: "22/02/2026", day: 22, month: 2, checked: false },
  { date: "23/02/2026", day: 23, month: 2, checked: false },
  { date: "24/02/2026", day: 24, month: 2, checked: false },
];

const EventTet2026 = () => {
  const navigate = useNavigate();
  const [hoveredItem, setHoveredItem] = useState(null);
  const [user, setUser] = useState(null);
  const [attendance, setAttendance] = useState(initialAttendance);
  const [notification, setNotification] = useState(null);
  const [isClaimingAttendance, setIsClaimingAttendance] = useState(false);
  const [submitLink, setSubmitLink] = useState("");
  const [isClosed, setIsClosed] = useState(false);
  const [task, setTask] = useState({ id: 1, input: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [info, setInfo] = useState({});
  const [submitStatus, setSubmitStatus] = useState(false);
  const [submissionLoading, setSubmissionLoading] = useState(false);
  const [submissions, setSubmissions] = useState([]);
  const [showInvalidFbPopup, setShowInvalidFbPopup] = useState(false);
  const [showLinkUsedPopup, setShowLinkUsedPopup] = useState(false);
  const [showDailyTurnPopup, setShowDailyTurnPopup] = useState(false);
  // Pagination state for submissions
  const [submissionPagination, setSubmissionPagination] = useState({
    page: 1,
    limit: 10,
    totalCount: 0,
    totalPages: 0,
  });

  // Statistics state
  const [statistics, setStatistics] = useState({
    checkinDays: 0,
    submissions: 0,
    wateringTurns: 0,
    turnsEarned: 0,
    currentTurns: 0,
    rewards: {
      GOLD: 0,
      SILVER: 0,
      BRONZE: 0,
      BLESSING: 0,
    },
  });

  // Rewards state
  const [rewards, setRewards] = useState([]);
  const [rewardsLoading, setRewardsLoading] = useState(false);
  const [rewardsPagination, setRewardsPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  });

  // Top 3 Leaderboard state
  const [top3, setTop3] = useState([]);
  const [top3Loading, setTop3Loading] = useState(false);

  // Rank List By Submission state
  const [rankListBySubmission, setRankListBySubmission] = useState([]);
  const [rankBySubmissionLoading, setRankBySubmissionLoading] = useState(false);

  // Rank List By Reward state
  const [rankListByReward, setRankListByReward] = useState([]);
  const [rankByRewardLoading, setRankByRewardLoading] = useState(false);

  // Tree Watering state
  const [isWatering, setIsWatering] = useState(false);
  const [rewardModal, setRewardModal] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    // Kiểm tra trạng thái sự kiện (mở/đóng)
    // kiểm tra xem sự kiện đã qua ngày 24/2/2026 chưa
    const checkEventStatus = () => {
      const today = new Date();
      const eventEndDate = new Date(2026, 1, 25); // Tháng 1 là tháng 2 (0-indexed)
      if (today > eventEndDate) {
        setIsClosed(true);
      }
    };

    checkEventStatus();
  }, []);
  // Background music
  useEffect(() => {
    const audio = new Audio(NhacNenTet2026);
    audio.loop = true;
    audio.volume = 0.3; // Set volume to 30%

    // Auto play
    const playAudio = async () => {
      try {
        await audio.play();
      } catch (error) {
        console.log("Autoplay prevented:", error);
        // Nếu autoplay bị chặn, thử phát khi user tương tác
        const playOnInteraction = () => {
          audio.play();
          document.removeEventListener("click", playOnInteraction);
        };
        document.addEventListener("click", playOnInteraction);
      }
    };

    playAudio();

    // Cleanup
    return () => {
      audio.pause();
      audio.currentTime = 0;
    };
  }, []);

  // Lấy ngày hôm nay
  const today = new Date();
  const todayDay = today.getDate();
  const todayMonth = today.getMonth() + 1; // 0-indexed

  // Kiểm tra xem ngày có phải trong khoảng điểm danh không (13/2 - 24/2)
  const isInAttendanceRange =
    todayMonth === 2 && todayDay >= 13 && todayDay <= 24;

  // Xử lý điểm danh - gọi API claimDailyTurn
  const handleAttendanceCheck = async (dayIndex) => {
    if (isClaimingAttendance) return;

    let item = attendance[dayIndex];
    if (dayIndex === undefined) {
      // Kiểm tra điểm danh ngày hôm nay
      item = attendance.find(
        (it) => it.day === todayDay && it.month === todayMonth,
      );
    }

    // Chỉ cho phép điểm danh ngày hôm nay và chưa điểm danh
    if (item.day !== todayDay || item.month !== todayMonth || item.checked)
      return;

    try {
      setIsClaimingAttendance(true);

      // TODO: Thay userEventId và event bằng giá trị thực tế
      const userEventId = user?.id || "demo_user";
      const event = "minigametet2026";

      const response = await treePlanting.claimDailyTurn({
        userEventId,
        event,
      });

      if (response?.success) {
        // Cập nhật trạng thái điểm danh
        const newAttendance = [...attendance];
        newAttendance[dayIndex].checked = true;
        setAttendance(newAttendance);

        setShowDailyTurnPopup(true);
        await fetchUserStatistics();
      } else {
        setNotification({
          type: "info",
          message: response.message || "Bạn đã điểm danh hôm nay rồi!",
        });
      }
    } catch (error) {
      console.error("Error claiming daily turn:", error);
      setNotification({
        type: "error",
        message: "Có lỗi xảy ra khi điểm danh!",
      });
    } finally {
      setIsClaimingAttendance(false);
    }
  };

  const handleSubmit = async () => {
    if (isClosed) {
      alert("Đã hết thời gian nộp bài. Hệ thống đã đóng nhận bài thi!");
      return;
    }

    // Validate link Facebook
    if (!submitLink.startsWith("https://www.facebook.com/")) {
      setShowInvalidFbPopup(true);
      return;
    }

    try {
      setIsLoading(true);
      const result = await mission.createSubmission({
        userEventId: info.id,
        mission: 1,
        link: submitLink,
      });
      if (result.message === "Submission created successfully") {
        setSubmitStatus(true);
        setSubmitLink("");
        await fetchUserStatistics();
        // Refresh submissions after successful submit and reset to first page
        // setSubmissionPagination((prev) => ({ ...prev, page: 1 }));
        await fetchSubmissions(1, submissionPagination.limit);
      } else if (
        result.message === "Link đã được sử dụng trong một submission khác"
      ) {
        setShowLinkUsedPopup(true);
      } else {
        throw new Error(result.message || "Failed to submit task");
      }
    } catch (error) {
      if (
        error.message ===
        "Request failed with status: 400, Link đã được sử dụng trong một submission khác"
      ) {
        setShowLinkUsedPopup(true);
        return;
      }
      console.error("Error submitting task:", error);
      alert(error.message || "Failed to submit task");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSubmissions = async (page = 1, limit = 2) => {
    try {
      setSubmissionLoading(true);
      const response = await mission.getSubmissionById({
        userEventId: info.id,
        page: page,
        limit: limit,
      });

      if (response) {
        setSubmissions(
          response.submissions?.rows || response.submissions || [],
        );
        const totalCount = response.totalCount || 0;
        const totalPages = Math.ceil(totalCount / limit);

        setSubmissionPagination({
          page: page,
          limit: limit,
          totalCount: totalCount,
          totalPages: totalPages,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setSubmissionLoading(false);
    }
  };

  const fetchUserEvent = async () => {
    try {
      setIsLoading(true);
      const response = await userEvent.getUserEvent({
        mail: sessionStorage.getItem("mail"),
        event: "minigametet2026",
      });
      if (response) {
        // console.log("User events fetched successfully:", response);
        setInfo({
          name: response?.userEvent?.name || "User",
          mail: response?.user365?.mail || "",
          photo: response?.user365?.photo || "",
          totalScore: response?.result?.score + response?.result?.fbScore || 0,
          mission1Score: response?.result?.mission1Score || 0,
          mission2Score: response?.result?.mission2Score || 0,
          mission3Score: response?.result?.mission3Score || 0,
          mission4Score: response?.result?.mission4Score || 0,
          fbScore: response?.result?.fbScore || 0,
          id: response?.userEvent?.id || "",
          department: response?.userEvent?.donvi || "",
        });
        setUser(response.userEvent);
      }
    } catch (error) {
      console.error("Error fetching user events:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchUserStatistics = async () => {
    if (!info.id) return;
    try {
      const response = await treePlanting.getUserStatistics(
        info.id,
        "minigametet2026",
      );
      if (response?.success) {
        setStatistics(response.data);
      }
    } catch (error) {
      console.error("Error fetching statistics:", error);
    }
  };

  const fetchUserRewards = async (page = 1, limit = 10) => {
    if (!info.id) return;
    try {
      setRewardsLoading(true);
      const response = await treePlanting.getUserRewards(
        info.id,
        "minigametet2026",
        page,
        limit,
      );
      if (response?.success) {
        setRewards(response.data.rewards || []);
        setRewardsPagination(response.data.pagination);
      }
    } catch (error) {
      console.error("Error fetching rewards:", error);
    } finally {
      setRewardsLoading(false);
    }
  };

  const fetchTop3 = async () => {
    try {
      setTop3Loading(true);
      const response = await treePlanting.getTop3("minigametet2026");
      if (response?.success) {
        setTop3(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching top 3:", error);
    } finally {
      setTop3Loading(false);
    }
  };

  const fetchRankListBySubmission = async () => {
    try {
      setRankBySubmissionLoading(true);
      const response =
        await treePlanting.getTop10Submissions("minigametet2026");
      if (response?.success) {
        setRankListBySubmission(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching rank by submission:", error);
    } finally {
      setRankBySubmissionLoading(false);
    }
  };

  const fetchRankListByReward = async () => {
    try {
      setRankByRewardLoading(true);
      const response = await treePlanting.getTop10Rewards("minigametet2026");
      if (response?.success) {
        setRankListByReward(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching rank by reward:", error);
    } finally {
      setRankByRewardLoading(false);
    }
  };

  useEffect(() => {
    fetchUserEvent();
    // Fetch top 3 and rankings (không cần info.id)
    fetchTop3();
    fetchRankListBySubmission();
    fetchRankListByReward();

    // Auto refresh mỗi 1 phút
    const intervalId = setInterval(() => {
      fetchTop3();
      fetchRankListBySubmission();
      fetchRankListByReward();
    }, 600000); // 10 phút

    // Cleanup interval khi component unmount
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (!info.id) return;
    fetchSubmissions(submissionPagination.page, submissionPagination.limit);
    fetchUserStatistics();
    fetchUserRewards(rewardsPagination.page, rewardsPagination.limit);
  }, [info.id]);

  // Sync attendance from statistics.list_checkin_days
  useEffect(() => {
    if (
      statistics.list_checkin_days &&
      statistics.list_checkin_days.length > 0
    ) {
      const checkedDays = statistics.list_checkin_days.map((dateStr) => {
        const date = new Date(dateStr);
        return {
          day: date.getDate(),
          month: date.getMonth() + 1,
        };
      });

      setAttendance((prevAttendance) =>
        prevAttendance.map((item) => ({
          ...item,
          checked: checkedDays.some(
            (d) => d.day === item.day && d.month === item.month,
          ),
        })),
      );
    }
  }, [statistics.list_checkin_days]);

  const getRewardContent = (reward) => {
    if (!reward) return null;

    switch (reward.type) {
      case "GOLD":
        return {
          icon: <FaTrophy className="text-6xl text-yellow-400" />,
          title: "🎉 CHÚC MỪNG! 🎉",
          message: "Bạn đã nhận được H vàng!",
          bgGradient: "from-yellow-400 via-yellow-500 to-amber-600",
          confettiColor: "yellow",
        };
      case "SILVER":
        return {
          icon: <FaMedal className="text-6xl text-gray-300" />,
          title: "🎊 TUYỆT VỜI! 🎊",
          message: "Bạn đã nhận được H bạc!",
          bgGradient: "from-gray-300 via-gray-400 to-gray-500",
          confettiColor: "silver",
        };
      case "BRONZE":
        return {
          icon: <FaMedal className="text-6xl text-orange-700" />,
          title: "👏 XUẤT SẮC! 👏",
          message: "Bạn đã nhận được H đồng!",
          bgGradient: "from-orange-600 via-orange-700 to-orange-800",
          confettiColor: "bronze",
        };
      default:
        return {
          icon: <FaStar className="text-6xl text-pink-400" />,
          title: "✨ LỜI CHÚC TẾT ✨",
          message: reward.content || reward.message,
          bgGradient: "from-pink-400 via-purple-500 to-indigo-600",
          confettiColor: "purple",
        };
    }
  };

  const handleWaterTree = async () => {
    if (isWatering || !info.id || statistics.currentTurns <= 0) return;

    try {
      setIsWatering(true);
      const response = await treePlanting.waterTree({
        userEventId: info.id,
        event: "minigametet2026",
        myuId: JSON.parse(sessionStorage.getItem("userInfoFromToken"))?.id,
      });
      
      if (response?.success) {
        // setNotification({
        //   type: "success",
        //   message: response.message,
        // });

        if (response.reward) {
          setTimeout(() => {
            setRewardModal(response.reward);
          }, 1200);
        }

        // Refresh statistics and rewards
        fetchUserStatistics();
        fetchUserRewards(rewardsPagination.page, rewardsPagination.limit);
      } else if (response?.success === false) {
        // Xử lý trường hợp API trả về success: false
        alert(response.message || "Bạn không còn lượt tưới cây!");
      } else {
        // Xử lý trường hợp response undefined hoặc không có success field
        setNotification({
          type: "error",
          message: "Có lỗi xảy ra khi tưới cây!",
        });
      }
    } catch (error) {
      console.error("Error watering tree:", error);
      setNotification({
        type: "error",
        message: "Có lỗi xảy ra khi tưới cây!",
      });
    } finally {
      setTimeout(() => {
        setIsWatering(false);
      }, 800);
    }
  };

  return (
    <>
      {/* Notification */}
      {notification && (
        <Noti
          message={<span>{notification.message}</span>}
          onClose={() => setNotification(null)}
        />
      )}

      {submitStatus && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm animate-fadeIn">
          <div className="relative max-w-md w-full md:w-11/12 mx-auto animate-scaleIn">
            <button
              onClick={() => setSubmitStatus(false)}
              className="relative w-full cursor-pointer hover:scale-105 transition-transform"
            >
              <img
                src={submitPopup}
                alt="Popup sự kiện đóng"
                className="w-full h-auto object-contain"
              />
            </button>
          </div>
        </div>
      )}

      {showInvalidFbPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm animate-fadeIn">
          <div className="relative max-w-md w-full md:w-11/12 mx-auto animate-scaleIn">
            <button
              onClick={() => setShowInvalidFbPopup(false)}
              className="relative w-full cursor-pointer hover:scale-105 transition-transform"
            >
              <img
                src={validateFBLink}
                alt="Link Facebook không hợp lệ"
                className="w-full h-auto object-contain"
              />
            </button>
          </div>
        </div>
      )}

      {showLinkUsedPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm animate-fadeIn">
          <div className="relative max-w-md w-full md:w-11/12 mx-auto animate-scaleIn">
            <button
              onClick={() => setShowLinkUsedPopup(false)}
              className="relative w-full cursor-pointer hover:scale-105 transition-transform"
            >
              <img
                src={Linkdasudung}
                alt="Link đã được sử dụng"
                className="w-full h-auto object-contain"
              />
            </button>
          </div>
        </div>
      )}

      {showDailyTurnPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm animate-fadeIn">
          <div className="relative max-w-md w-full md:w-11/12 mx-auto animate-scaleIn">
            <button
              onClick={() => setShowDailyTurnPopup(false)}
              className="relative w-full cursor-pointer hover:scale-105 transition-transform"
            >
              <img
                src={Popuptangluottuoi}
                alt="Nhận thêm lượt tưới"
                className="w-full h-auto object-contain"
              />
            </button>
          </div>
        </div>
      )}

      {/* Reward Modal */}
      {rewardModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm animate-fadeIn">
          <div className="relative max-w-md w-full md:w-11/12 mx-auto animate-scaleIn">
            <button
              onClick={() => setRewardModal(null)}
              className="relative w-full cursor-pointer hover:scale-105 transition-transform"
            >
              {rewardModal.type === "GOLD" ? (
                <img
                  src={PopUpHvang}
                  alt="Popup phần thưởng"
                  className="w-full h-auto object-contain"
                />
              ) : rewardModal.type === "SILVER" ? (
                <img
                  src={PopUpHbac}
                  alt="Popup phần thưởng"
                  className="w-full h-auto object-contain"
                />
              ) : rewardModal.type === "BRONZE" ? (
                <img
                  src={PopUpHdong}
                  alt="Popup phần thưởng"
                  className="w-full h-auto object-contain"
                />
              ) : (
                <div className="relative w-full">
                  <img
                    src={Loichuc}
                    alt="Lời chúc"
                    className="w-full h-auto object-contain"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <p className="text-center text-white font-bold text-lg px-6 drop-shadow-lg">
                      {rewardModal.content}
                    </p>
                  </div>
                </div>
              )}
            </button>
          </div>
        </div>
      )}

      <div className="event_2026">
        <div
          style={{
            backgroundImage: `url(${bg1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
          className="phan1 -z-20"
        >
          <div className="w-full md:w-11/12  mx-auto p-4 flex flex-col items-center">
            <img
              src={chuDe}
              alt="Chủ đề"
              className="w-full md:w-[60%] lg:w-[40%] object-contain mt-4 mb-4"
            />
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8 w-full">
              <div
                id="caytailoc"
                className="flex md:hidden flex-col items-center gap-4 my-4"
              >
                <img
                  src={cayTaiLoc}
                  alt="Cây Tài Lộc"
                  className={`cursor-pointer w-full object-contain transform transition-transform duration-300 ${
                    hoveredItem === "cayTaiLoc" ? "scale-105" : ""
                  }`}
                  onMouseEnter={() => setHoveredItem("cayTaiLoc")}
                  onMouseLeave={() => setHoveredItem(null)}
                />
                {/* button Tuoicay */}
                <div className="flex gap-4 items-center">
                  <button
                    className="disabled:cursor-not-allowed h-auto relative cursor-pointer w-52 font-bold rounded-md transition disabled:opacity-50"
                    onClick={() => {
                      handleWaterTree();
                    }}
                    disabled={
                      isClosed || statistics.currentTurns <= 0 || isWatering
                    }
                  >
                    <img
                      src={Buttontuoicay}
                      alt="Tưới cây"
                      className="w-full z-10 h-auto object-cover"
                    />
                    <div className="absolute text-sm lg:text-base top-0 right-0 w-4/5 h-full flex items-center justify-center py-4 pr-[10%] z-20 text-ellipsis bg-gradient-to-b from-[#f9fae4] to-[#fedc69] bg-clip-text text-transparent italic">
                      {isWatering ? "Đang tưới..." : "Tưới Cây"}
                    </div>
                  </button>
                  <button
                    className="disabled:cursor-not-allowed flex items-end pt-3 h-auto relative cursor-pointer w-auto font-bold rounded-md transition"
                    onClick={() => {
                      handleWaterTree();
                    }}
                    disabled={true}
                  >
                    <img
                      src={ButtonLuottuoi}
                      alt="Tưới cây"
                      className=" h-[60px]  z-[2] object-contain "
                    />
                    <div className="absolute text-sm lg:text-base top-0 translate-y-1 right-0 w-full h-[62px] flex items-center justify-center p-4 z-[5] text-ellipsis bg-gradient-to-b from-[#f9fae4] to-[#fedc69] bg-clip-text text-transparent italic">
                      {"Bạn còn " + statistics.currentTurns + " lượt tưới"}
                    </div>
                  </button>
                </div>

                <img
                  src={POPUPCheckingif}
                  alt="Popup Checking"
                  className=" w-[300px] object-contain cursor-pointer"
                  onClick={() => {
                    const element = document.getElementById("bangnhiemvu");
                    if (element) {
                      setTimeout(() => {
                        element.scrollIntoView({ behavior: "smooth", block: "start" });
                      }, 100);
                    }
                  }}
                />
                <img
                  src={POPUPFacebookgif}
                  alt="Popup Facebook"
                  className=" w-[300px] object-contain cursor-pointer"
                  onClick={() => {
                    const element = document.getElementById("bangnhiemvu");
                    if (element) {
                      setTimeout(() => {
                        element.scrollIntoView({ behavior: "smooth", block: "start" });
                      }, 100);
                    }
                  }}
                />
              </div>
              <Boxtitle id="thongtinfarmthu" className="col-span-1">
                <div className="absolute flex justify-center w-full top-0 left-1/2 -translate-x-1/2 -translate-y-1/3">
                  <Title
                    width="80%"
                    textColor="white"
                    text="THÔNG TIN FARM THỦ"
                    className="font-bold"
                  />
                </div>
                <div className="pt-8 flex flex-col items-center gap-4 w-full">
                  <div className="flex items-center gap-2 w-[90%]">
                    <img
                      src={`data:image/png;base64,${info.photo}`}
                      className="w-20 h-20 rounded-full avatar"
                      alt=""
                    />
                    <div className="text-orange-400">
                      <div className="font-bold text-xl">{info.name}</div>
                      {/* <div className="font-bold">ID: {info.id}</div> */}
                      <div className="font-bold">Đơn vị: {info.department}</div>
                      <div className="font-bold">
                        Thứ hạng: {statistics.rank}
                      </div>
                    </div>
                  </div>
                  <Title
                    width="100%"
                    textColor="white"
                    text="BẢNG THÀNH TÍCH"
                    className="font-bold text-white"
                  />
                  <div className="border-b-[#ff8f40] border-b-2 grid grid-cols-6 text-[#ff8f40] font-bold w-[90%] text-center">
                    <img
                      src={binhTuoiCay}
                      className="col-span-1 h-5 object-cover"
                      alt=""
                    ></img>{" "}
                    <span className="col-span-4 flex items-center">
                      Lượt tưới
                    </span>
                    <span className="col-span-1 flex items-center">
                      {statistics.turnsEarned}
                    </span>
                  </div>
                  <div className="border-b-[#ff8f40] border-b-2 grid grid-cols-6 text-[#ff8f40] font-bold w-[90%] text-center">
                    <img
                      src={diemDanh}
                      className="col-span-1 h-5 object-cover"
                      alt=""
                    ></img>
                    <span className="col-span-4 flex items-center">
                      Chỉ số chăm chỉ
                    </span>
                    <span className="col-span-1 flex items-center">
                      {statistics.checkinDays}
                    </span>
                  </div>
                  <div className="border-b-[#ff8f40] border-b-2 grid grid-cols-6 text-[#ff8f40] font-bold w-[90%] text-center">
                    <img
                      src={Facebook}
                      className="col-span-1 h-5 object-cover"
                      alt=""
                    ></img>
                    <span className="col-span-4 flex items-center">
                      Chỉ số lan tỏa
                    </span>
                    <span className="col-span-1 flex items-center">
                      {statistics.submissions}
                    </span>
                  </div>

                  {/* thông tin H vàng, H bạc, H đồng */}

                  <div className="mt-4"></div>
                  <div className="border-b-[#ff8f40] border-b-2 grid grid-cols-6 text-[#ff8f40] font-bold w-[90%] text-center">
                    <img
                      src={HH1}
                      className="col-span-1 h-5 object-cover"
                      alt=""
                    ></img>{" "}
                    <span className="col-span-4 flex items-center">H vàng</span>
                    <span className="col-span-1 flex items-center">
                      {statistics.rewards.GOLD}
                    </span>
                  </div>
                  <div className="border-b-[#ff8f40] border-b-2 grid grid-cols-6 text-[#ff8f40] font-bold w-[90%] text-center">
                    <img
                      src={HH2}
                      className="col-span-1 h-5 object-cover"
                      alt=""
                    ></img>
                    <span className="col-span-4 flex items-center">H bạc</span>
                    <span className="col-span-1 flex items-center">
                      {statistics.rewards.SILVER}
                    </span>
                  </div>
                  <div className="border-b-[#ff8f40] border-b-2 grid grid-cols-6 text-[#ff8f40] font-bold w-[90%] text-center">
                    <img
                      src={HH3}
                      className="col-span-1 h-5 object-cover"
                      alt=""
                    ></img>
                    <span className="col-span-4 flex items-center">H đồng</span>
                    <span className="col-span-1 flex items-center">
                      {statistics.rewards.BRONZE}
                    </span>
                  </div>
                  <div className="mb-4"></div>
                </div>
              </Boxtitle>
              <div
                id="caytailoc"
                className="hidden md:flex md:flex-col md:items-center md:col-span-2 md:gap-4 md:my-4"
              >
                <img
                  src={cayTaiLoc}
                  alt="Cây Tài Lộc"
                  className={`cursor-pointer min-h-[450px] object-contain transform transition-transform duration-300 ${
                    hoveredItem === "cayTaiLoc" ? "scale-105" : ""
                  }`}
                  onMouseEnter={() => setHoveredItem("cayTaiLoc")}
                  onMouseLeave={() => setHoveredItem(null)}
                />
                {/* button Tuoicay */}
                <div className="flex gap-4 items-center">
                  <button
                    className="disabled:cursor-not-allowed h-auto relative cursor-pointer w-52 font-bold rounded-md transition disabled:opacity-50"
                    onClick={() => {
                      handleWaterTree();
                    }}
                    disabled={
                      isClosed || statistics.currentTurns <= 0 || isWatering
                    }
                  >
                    <img
                      src={Buttontuoicay}
                      alt="Tưới cây"
                      className="w-full z-10 h-auto object-cover"
                    />
                    <div className="absolute text-sm lg:text-base top-0 right-0 w-4/5 h-full flex items-center justify-center py-4 pr-[10%] z-20 text-ellipsis bg-gradient-to-b from-[#f9fae4] to-[#fedc69] bg-clip-text text-transparent italic">
                      {isWatering ? "Đang tưới..." : "Tưới Cây"}
                    </div>
                  </button>
                  <button
                    className="disabled:cursor-not-allowed flex items-end pt-3 h-auto relative cursor-pointer w-auto font-bold rounded-md transition"
                    onClick={() => {
                      handleWaterTree();
                    }}
                    disabled={true}
                  >
                    <img
                      src={ButtonLuottuoi}
                      alt="Tưới cây"
                      className=" h-[60px]  z-[2] object-contain "
                    />
                    <div className="absolute text-sm lg:text-base top-0 translate-y-1 right-0 w-full h-[62px] flex items-center justify-center p-4 z-[5] text-ellipsis bg-gradient-to-b from-[#f9fae4] to-[#fedc69] bg-clip-text text-transparent italic">
                      {"Bạn còn " + statistics.currentTurns + " lượt tưới"}
                    </div>
                  </button>
                </div>

                <div className="flex items-center justify-between gap-4">
                  <img
                    src={POPUPCheckingif}
                    alt="Popup Checking"
                    className="h-20 object-contain"
                  />
                  <img
                    src={POPUPFacebookgif}
                    alt="Popup Facebook"
                    className="h-20 object-contain "
                  />
                </div>
              </div>
              <Boxtitle  className="md:col-span-1">
                <div id="bangnhiemvu" className="absolute flex justify-center w-full top-0 left-1/2 -translate-x-1/2 -translate-y-1/3">
                  <Title
                    width="80%"
                    textColor="white"
                    text="BẢNG NHIỆM VỤ"
                    className="font-bold"
                  />
                </div>
                <div className="pt-8 flex flex-col items-center gap-4 w-full p-4">
                  <div className="grid grid-cols-3 gap-2 w-full items-center">
                    <span className="col-span-2 text-[#ff8f40] font-bold text-xl">
                      ĐIỂM DANH HẰNG NGÀY
                    </span>
                    <img
                      alt=""
                      src={diemDanh}
                      className="h-20 object-cover"
                    ></img>
                  </div>

                  {/* Render Checkbox điểm danh */}
                  <div className="w-full">
                    {/* Dòng 1: 13/2 - 17/2 (5 ngày) */}
                    <div className="grid grid-cols-5 gap-2 mb-2">
                      {attendance.slice(0, 5).map((item, index) => {
                        const isToday =
                          isInAttendanceRange &&
                          item.day === todayDay &&
                          item.month === todayMonth;
                        const canCheck = isToday && !item.checked;

                        return (
                          <div
                            key={index}
                            className="flex flex-col items-center"
                          >
                            <span
                              className={`text-xs mb-1 ${isToday ? "text-yellow-300 font-bold" : "text-[#ff8f40]"}`}
                            >
                              {item.day}/{item.month}
                            </span>
                            <Checkbox
                              checked={item.checked}
                              disabled={!canCheck || isClaimingAttendance}
                              blink={canCheck}
                              onChange={() => handleAttendanceCheck(index)}
                              size="md"
                            />
                          </div>
                        );
                      })}
                    </div>
                    {/* Dòng 2: 18/2 - 22/2 (5 ngày) */}
                    <div className="grid grid-cols-5 gap-2 mb-2">
                      {attendance.slice(5, 10).map((item, index) => {
                        const isToday =
                          isInAttendanceRange &&
                          item.day === todayDay &&
                          item.month === todayMonth;
                        const canCheck = isToday && !item.checked;

                        return (
                          <div
                            key={index + 5}
                            className="flex flex-col items-center"
                          >
                            <span
                              className={`text-xs mb-1 ${isToday ? "text-yellow-300 font-bold" : "text-[#ff8f40]"}`}
                            >
                              {item.day}/{item.month}
                            </span>
                            <Checkbox
                              checked={item.checked}
                              disabled={!canCheck || isClaimingAttendance}
                              blink={canCheck}
                              onChange={() => handleAttendanceCheck(index + 5)}
                              size="md"
                            />
                          </div>
                        );
                      })}
                    </div>
                    {/* Dòng 3: 23/2 - 24/2 (2 ngày) */}
                    <div className="grid grid-cols-5 gap-2 mb-2">
                      {attendance.slice(10, 12).map((item, index) => {
                        const isToday =
                          isInAttendanceRange &&
                          item.day === todayDay &&
                          item.month === todayMonth;
                        const canCheck = isToday && !item.checked;

                        return (
                          <div
                            key={index + 10}
                            className="flex flex-col items-center"
                          >
                            <span
                              className={`text-xs mb-1 ${isToday ? "text-yellow-300 font-bold" : "text-[#ff8f40]"}`}
                            >
                              {item.day}/{item.month}
                            </span>
                            <Checkbox
                              checked={item.checked}
                              disabled={!canCheck || isClaimingAttendance}
                              blink={canCheck}
                              onChange={() => handleAttendanceCheck(index + 10)}
                              size="md"
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <span className="col-span-2 text-[#ff8f40] font-bold text-xl mt-4">
                    NHIỆM VỤ LAN TỎA
                  </span>
                  <input
                    type="text"
                    className="flex-1 w-full text-[#ff8f40] font-bold border-2 border-yellow-600 bg-orange-50  px-3 py-2 text-lg rounded-md focus:outline-none focus:ring-1 focus:ring-[#0253e1]"
                    placeholder="Nhập link bài viết"
                    value={submitLink}
                    onChange={(e) => setSubmitLink(e.target.value)}
                    disabled={isClosed}
                  />
                  <button
                    className="bg-orange-400 disabled:cursor-not-allowed border-2 border-yellow-600 cursor-pointer text-yellow-400 w-full font-bold py-2 px-4 rounded-md transition disabled:opacity-50"
                    onClick={() => {
                      handleSubmit();
                    }}
                    disabled={isClosed || submitLink.trim() === ""}
                  >
                    THU THẬP LƯỢT TƯỚI
                  </button>
                  <span className="font-bold text-[#ff8f40]">
                    Hãy nhập link bài đăng Cuộc thi ảnh trên Facebook vào ô trên
                    để thu thập thêm lượt tưới cây
                  </span>
                </div>
              </Boxtitle>
            </div>

            <div className="w-full md:w-11/12  mx-auto flex flex-col gap-4 items-center">
              <img
                src={Top3FarmThu}
                alt="Top 3 Farm Thủ"
                className="mt-8 mb-4 object-contain"
                style={{ width: 400 }}
              />
              {top3Loading ? (
                <div className="text-center text-orange-400 font-bold text-xl py-8">
                  Đang tải...
                </div>
              ) : top3.length === 0 ? (
                <div className="text-center text-orange-400 font-bold text-xl py-8">
                  Chưa có dữ liệu Top 3
                </div>
              ) : (
                <div className="w-full mx-auto text-black mt-8">
                  {/* Hàng trên: Top 1 */}
                  {/* {top3[0] && (
                    <div className="flex justify-center mb-6">
                      <div className="w-full md:w-2/3 lg:w-1/2">
                        <Farmthu frameType="gold">
                          <div className="relative z-10 w-[70%] flex flex-col mx-auto items-center justify-center">
                            <div className="flex items-center w-[70%]">
                              <img
                                src={`data:image/png;base64,${top3[0]?.User365?.photo}`}
                                className="w-16 h-16 md:w-24 md:h-24 rounded-full avatar border-4 border-yellow-400"
                                alt=""
                              />
                              <div className="flex flex-col text-orange-400">
                                <h4 className="text-sm md:text-3xl font-bold ml-4">
                                  {top3[0]?.UserEvent1?.name}
                                </h4>
                                <div className="text-sm md:text-xl font-bold ml-4">
                                  ID: {top3[0]?.userEventId}
                                </div>
                                <div className="text-sm md:text-xl font-bold ml-4">
                                  Đơn vị: {top3[0]?.UserEvent1?.donvi}
                                </div>
                              </div>
                            </div>

                            <div className="grid grid-cols-2 gap-4 justify-between mt-4 w-[70%]">
                              <div className="flex flex-col items-center w-full gap-2">
                                <div className="text-yellow-300 border-b-2 border-yellow-300 pb-1 font-bold md:text-2xl flex gap-2 items-center w-full justify-between">
                                  <img
                                    src={binhTuoiCay}
                                    alt="Bình Tưới Cây"
                                    className="w-8 h-8 object-cover"
                                  />
                                  <span className="text-base font-bold">
                                    {top3[0]?.turns?.totalTurnEarn || 0}
                                  </span>
                                </div>
                                <div className="text-yellow-300 border-b-2 border-yellow-300 pb-1 font-bold md:text-2xl flex gap-2 items-center w-full justify-between">
                                  <img
                                    src={chiSoChamChi}
                                    alt="Chỉ số chăm chỉ"
                                    className="w-8 h-8 object-cover"
                                  />
                                  <span className="text-base font-bold">
                                    {top3[0]?.checkinDays}
                                  </span>
                                </div>
                                <div className="text-yellow-300 border-b-2 border-yellow-300 pb-1 font-bold md:text-2xl flex gap-2 items-center w-full justify-between">
                                  <img
                                    src={chiSoLanToa}
                                    alt="Chỉ số lan tỏa"
                                    className="w-8 h-8 object-cover"
                                  />
                                  <span className="text-base font-bold">
                                    {top3[0]?.submissionCount}
                                  </span>
                                </div>
                              </div>
                              <div className="flex flex-col items-center w-full gap-2">
                                <div className="text-yellow-300 border-b-2 border-yellow-300 pb-1 font-bold md:text-2xl flex gap-2 items-center w-full justify-between">
                                  <img
                                    src={HH1}
                                    alt="H vàng"
                                    className="w-8 h-8 object-cover"
                                  />
                                  <span className="text-base font-bold">
                                    {top3[0]?.goldCount}
                                  </span>
                                </div>
                                <div className="text-yellow-300 border-b-2 border-yellow-300 pb-1 font-bold md:text-2xl flex gap-2 items-center w-full justify-between">
                                  <img
                                    src={HH2}
                                    alt="H bạc"
                                    className="w-8 h-8 object-cover"
                                  />
                                  <span className="text-base font-bold">
                                    {top3[0]?.silverCount}
                                  </span>
                                </div>
                                <div className="text-yellow-300 border-b-2 border-yellow-300 pb-1 font-bold md:text-2xl flex gap-2 items-center w-full justify-between">
                                  <img
                                    src={HH3}
                                    alt="H đồng"
                                    className="w-8 h-8 object-cover"
                                  />
                                  <span className="text-base font-bold">
                                    {top3[0]?.bronzeCount}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Farmthu>
                      </div>
                    </div>
                  )} */}

                  {/* Hàng dưới: Top 2 và Top 3 - Grid 2 cột trên md, 1 cột trên mobile */}
                  {/* {(top3[1] || top3[2]) && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {top3[1] && (
                        <div className="w-full">
                          <Farmthu frameType="silver">
                            <div className="relative z-10 w-[70%] flex flex-col mx-auto items-center justify-center">
                              <div className="flex items-center w-[70%]">
                                <img
                                  src={`data:image/png;base64,${top3[1]?.User365?.photo}`}
                                  className="w-16 h-16 md:w-24 md:h-24 rounded-full avatar border-4 border-yellow-400"
                                  alt=""
                                />
                                <div className="flex flex-col text-orange-400">
                                  <h4 className="text-sm md:text-3xl font-bold ml-4">
                                    {top3[1]?.UserEvent1?.name}
                                  </h4>
                                  <div className="text-sm md:text-xl font-bold ml-4">
                                    ID: {top3[1]?.userEventId}
                                  </div>
                                  <div className="text-sm md:text-xl font-bold ml-4">
                                    Đơn vị: {top3[1]?.UserEvent1?.donvi}
                                  </div>
                                </div>
                              </div>

                              <div className="grid grid-cols-2 gap-4 justify-between mt-4 w-[70%]">
                                <div className="flex flex-col items-center w-full gap-2">
                                  <div className="text-yellow-300 border-b-2 border-yellow-300 pb-1 font-bold md:text-2xl flex gap-2 items-center w-full justify-between">
                                    <img
                                      src={binhTuoiCay}
                                      alt="Bình Tưới Cây"
                                      className="w-8 h-8 object-cover"
                                    />
                                    <span className="text-base font-bold">
                                      {top3[1]?.turns?.totalTurnEarn || 0}
                                    </span>
                                  </div>
                                  <div className="text-yellow-300 border-b-2 border-yellow-300 pb-1 font-bold md:text-2xl flex gap-2 items-center w-full justify-between">
                                    <img
                                      src={chiSoChamChi}
                                      alt="Chỉ số chăm chỉ"
                                      className="w-8 h-8 object-cover"
                                    />
                                    <span className="text-base font-bold">
                                      {top3[1]?.checkinDays}
                                    </span>
                                  </div>
                                  <div className="text-yellow-300 border-b-2 border-yellow-300 pb-1 font-bold md:text-2xl flex gap-2 items-center w-full justify-between">
                                    <img
                                      src={chiSoLanToa}
                                      alt="Chỉ số lan tỏa"
                                      className="w-8 h-8 object-cover"
                                    />
                                    <span className="text-base font-bold">
                                      {top3[1]?.submissionCount}
                                    </span>
                                  </div>
                                </div>
                                <div className="flex flex-col items-center w-full gap-2">
                                  <div className="text-yellow-300 border-b-2 border-yellow-300 pb-1 font-bold md:text-2xl flex gap-2 items-center w-full justify-between">
                                    <img
                                      src={HH1}
                                      alt="H vàng"
                                      className="w-8 h-8 object-cover"
                                    />
                                    <span className="text-base font-bold">
                                      {top3[1]?.goldCount}
                                    </span>
                                  </div>
                                  <div className="text-yellow-300 border-b-2 border-yellow-300 pb-1 font-bold md:text-2xl flex gap-2 items-center w-full justify-between">
                                    <img
                                      src={HH2}
                                      alt="H bạc"
                                      className="w-8 h-8 object-cover"
                                    />
                                    <span className="text-base font-bold">
                                      {top3[1]?.silverCount}
                                    </span>
                                  </div>
                                  <div className="text-yellow-300 border-b-2 border-yellow-300 pb-1 font-bold md:text-2xl flex gap-2 items-center w-full justify-between">
                                    <img
                                      src={HH3}
                                      alt="H đồng"
                                      className="w-8 h-8 object-cover"
                                    />
                                    <span className="text-base font-bold">
                                      {top3[1]?.bronzeCount}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Farmthu>
                        </div>
                      )}

                      {top3[2] && (
                        <div className="w-full">
                          <Farmthu frameType="bronze">
                            <div className="relative z-10 w-[70%] flex flex-col mx-auto items-center justify-center">
                              <div className="flex items-center w-[70%]">
                                <img
                                  src={`data:image/png;base64,${top3[2]?.User365?.photo}`}
                                  className="w-16 h-16 md:w-24 md:h-24 rounded-full avatar border-4 border-yellow-400"
                                  alt=""
                                />
                                <div className="flex flex-col text-orange-400">
                                  <h4 className="text-sm md:text-3xl font-bold ml-4">
                                    {top3[2]?.UserEvent1?.name}
                                  </h4>
                                  <div className="text-sm md:text-xl font-bold ml-4">
                                    ID: {top3[2]?.userEventId}
                                  </div>
                                  <div className="text-sm md:text-xl font-bold ml-4">
                                    Đơn vị: {top3[2]?.UserEvent1?.donvi}
                                  </div>
                                </div>
                              </div>

                              <div className="grid grid-cols-2 gap-4 justify-between mt-4 w-[70%]">
                                <div className="flex flex-col items-center w-full gap-2">
                                  <div className="text-yellow-300 border-b-2 border-yellow-300 pb-1 font-bold md:text-2xl flex gap-2 items-center w-full justify-between">
                                    <img
                                      src={binhTuoiCay}
                                      alt="Bình Tưới Cây"
                                      className="w-8 h-8 object-cover"
                                    />
                                    <span className="text-base font-bold">
                                      {top3[2]?.turns?.totalTurnEarn || 0}
                                    </span>
                                  </div>
                                  <div className="text-yellow-300 border-b-2 border-yellow-300 pb-1 font-bold md:text-2xl flex gap-2 items-center w-full justify-between">
                                    <img
                                      src={chiSoChamChi}
                                      alt="Chỉ số chăm chỉ"
                                      className="w-8 h-8 object-cover"
                                    />
                                    <span className="text-base font-bold">
                                      {top3[2]?.checkinDays}
                                    </span>
                                  </div>
                                  <div className="text-yellow-300 border-b-2 border-yellow-300 pb-1 font-bold md:text-2xl flex gap-2 items-center w-full justify-between">
                                    <img
                                      src={chiSoLanToa}
                                      alt="Chỉ số lan tỏa"
                                      className="w-8 h-8 object-cover"
                                    />
                                    <span className="text-base font-bold">
                                      {top3[2]?.submissionCount}
                                    </span>
                                  </div>
                                </div>
                                <div className="flex flex-col items-center w-full gap-2">
                                  <div className="text-yellow-300 border-b-2 border-yellow-300 pb-1 font-bold md:text-2xl flex gap-2 items-center w-full justify-between">
                                    <img
                                      src={HH1}
                                      alt="H vàng"
                                      className="w-8 h-8 object-cover"
                                    />
                                    <span className="text-base font-bold">
                                      {top3[2]?.goldCount}
                                    </span>
                                  </div>
                                  <div className="text-yellow-300 border-b-2 border-yellow-300 pb-1 font-bold md:text-2xl flex gap-2 items-center w-full justify-between">
                                    <img
                                      src={HH2}
                                      alt="H bạc"
                                      className="w-8 h-8 object-cover"
                                    />
                                    <span className="text-base font-bold">
                                      {top3[2]?.silverCount}
                                    </span>
                                  </div>
                                  <div className="text-yellow-300 border-b-2 border-yellow-300 pb-1 font-bold md:text-2xl flex gap-2 items-center w-full justify-between">
                                    <img
                                      src={HH3}
                                      alt="H đồng"
                                      className="w-8 h-8 object-cover"
                                    />
                                    <span className="text-base font-bold">
                                      {top3[2]?.bronzeCount}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Farmthu>
                        </div>
                      )}
                    </div>
                  )} */}

                  <div className="flex justify-center items-end w-auto h-[300px] md:h-[400px]">
                    <div className="col-span-1 relative h-auto w-full">
                      <img
                        src={Top02}
                        alt="Cúp Vàng"
                        className="h-[360px] md:h-[400px] object-cover mx-auto"
                      />
                      <img
                        src={`data:image/png;base64,${top3[1]?.User365?.photo}`}
                        className="h-[30%] rounded-full avatar absolute top-[18.8%] left-[45%] -translate-x-1/2 transform"
                        alt=""
                      />
                      <div className="absolute top-[50%] left-1/2 -translate-x-1/2 transform">
                        <span className="text-white font-bold md:text-2xl flex gap-2 items-center justify-center text-center">
                          {top3[1]?.UserEvent1?.name}
                        </span>
                      </div>
                    </div>
                    <div className="col-span-1 relative h-auto w-full">
                      <img
                        src={Top01}
                        alt="Cúp Vàng"
                        className="h-[360px] md:h-[400px] object-cover mx-auto"
                      />
                      <img
                        src={`data:image/png;base64,${top3[0]?.User365?.photo}`}
                        className="h-[33%] md:w-24 md:h-24 rounded-full avatar absolute top-[12.8%] left-1/2 -translate-x-1/2 transform"
                        alt=""
                      />
                      <div className="absolute top-[50%] left-1/2 -translate-x-1/2 transform">
                        <span className="text-white font-bold md:text-2xl flex gap-2 items-center justify-center text-center">
                          {top3[0]?.UserEvent1?.name}
                        </span>
                      </div>
                    </div>
                    <div className="col-span-1 relative h-auto w-full">
                      <img
                        src={Top03}
                        alt="Cúp Vàng"
                        className="h-[360px] object-cover mx-auto"
                      />
                      <img
                        src={`data:image/png;base64,${top3[2]?.User365?.photo}`}
                        className="h-[28%] md:w-24 md:h-24 rounded-full avatar absolute top-[33%] left-1/2 -translate-x-1/2 transform"
                        alt=""
                      />
                      <div className="absolute top-[60%] left-1/2 -translate-x-1/2 transform">
                        <span className="text-white font-bold md:text-2xl flex gap-2 items-center justify-center text-center">
                          {top3[2]?.UserEvent1?.name}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* bảng xếp hạng */}
        <div
          style={{
            backgroundImage: `url(${bg2})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
          className="bangxephanglantoa -z-20 w-full min-h-screen py-4 flex flex-col items-center justify-center"
        >
          <div className="w-full md:w-11/12  mx-auto p-4 grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="col-span-1 rounded-2xl bg-gradient-to-b from-[#46ccbb] to-[#465fd6] md:col-span-2 p-4 flex flex-col items-center gap-2">
              <img
                /* Render top 10 bảng xếp hạng MyU Coin */
                className="h-32"
                src={bangxephangmyucoin}
                alt="Bảng xếp hạng MyU Coin"
              />
              {rankListByReward && rankListByReward.length > 0 ? (
                <div className="flex flex-col w-full text-white text-lg">
                  {rankListByReward.slice(0, 10).map((item, index) => (
                    <div
                      key={item.userEventId}
                      className={`border-b-2 py-2 border-green-200 grid grid-cols-7 w-full text-center pb-1 ${
                        index === 0 ? "font-bold" : ""
                      }`}
                    >
                      <span className="col-span-1">{index + 1}</span>
                      <span className="col-span-3">
                        {item?.UserEvent1?.name}
                      </span>
                      <div className="col-span-3 grid grid-cols-3">
                        <span className="col-span-1 flex items-center gap-2">
                          {item?.goldCount}
                          <img
                            src={HH1}
                            alt=""
                            className="object-cover h-6"
                          ></img>
                        </span>
                        <span className="col-span-1 flex items-center gap-2">
                          {item?.silverCount}
                          <img
                            src={HH2}
                            alt=""
                            className="object-cover h-6"
                          ></img>
                        </span>
                        <span className="col-span-1 flex items-center gap-2">
                          {item?.bronzeCount}
                          <img
                            src={HH3}
                            alt=""
                            className="object-cover h-6"
                          ></img>
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center text-white py-4">
                  Chưa có dữ liệu
                </div>
              )}
            </div>
            {/* Bảng xếp hạng chăm chỉ */}
            <div className="col-span-1 rounded-2xl bg-gradient-to-b from-[#e1e452] to-[#46c723] p-4 flex flex-col items-center gap-2">
              <img
                className="h-32"
                src={bangxephanglantoa}
                alt="Bảng xếp hạng lân toả"
              />
              <div className="flex flex-col w-full text-white text-lg">
                {
                  /* Render top 10 bảng xếp hạng lan toả */
                  rankListBySubmission && rankListBySubmission.length > 0 ? (
                    rankListBySubmission.slice(0, 10).map((item, index) => (
                      <div
                        key={item.userEventId}
                        className={`border-b-2 py-2 border-green-200 grid grid-cols-5 w-full text-center pb-1 ${
                          index === 0 ? "font-bold" : ""
                        }`}
                      >
                        <span className="col-span-1">{index + 1}</span>
                        <span className="col-span-3">
                          {item?.UserEvent1?.name}
                        </span>
                        <span className="col-span-1">
                          {item?.submissionCount}
                        </span>
                      </div>
                    ))
                  ) : (
                    <div className="text-center text-white py-4">
                      Chưa có dữ liệu
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        </div>
        <img
          className="w-full object-cover bg-no-repeat"
          src={image}
          alt="Event Tet 2026"
        />

        {/* PHẦN THƯỞNG ĐÃ NHẬN và LỊCH SỬ SUBMISSION */}
        <div
          className="w-full py-8"
          style={{
            backgroundImage: `url(${bg1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="w-full md:w-11/12 mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* BẢNG PHẦN THƯỞNG ĐÃ NHẬN */}
              <div className="bg-orange-50/95 rounded-lg p-6 border-4 border-[#ff8f40] shadow-xl">
                <h2 className="text-2xl font-bold text-[#ff8f40] text-center mb-4">
                  🏆 PHẦN THƯỞNG ĐÃ NHẬN 🏆
                </h2>
                <div className="bg-white rounded-lg overflow-hidden max-h-96 overflow-y-auto">
                  {rewardsLoading ? (
                    <div className="p-4 text-center text-gray-500">
                      Đang tải...
                    </div>
                  ) : rewards && rewards.length > 0 ? (
                    <table className="w-full text-sm">
                      <thead className="bg-orange-400 text-yellow-400 sticky top-0">
                        <tr>
                          <th className="px-3 py-3 text-left font-bold">
                            Loại
                          </th>
                          <th className="px-3 py-3 text-left font-bold">
                            Nội dung
                          </th>
                          {/* <th className="px-3 py-3 text-center font-bold">
                            Lượt
                          </th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {rewards.map((reward, index) => (
                          <tr
                            key={reward.id}
                            className={
                              index % 2 === 0 ? "bg-white" : "bg-gray-50"
                            }
                          >
                            <td className="px-3 py-2">
                              <span
                                className={`inline-block px-2 py-1 rounded text-xs font-bold ${
                                  reward.rewardType === "GOLD"
                                    ? "bg-yellow-400 text-white"
                                    : reward.rewardType === "SILVER"
                                      ? "bg-gray-300 text-gray-700"
                                      : reward.rewardType === "BRONZE"
                                        ? "bg-orange-600 text-white"
                                        : "bg-pink-400 text-white"
                                }`}
                              >
                                {reward.rewardType === "GOLD"
                                  ? "🏆 VÀNG"
                                  : reward.rewardType === "SILVER"
                                    ? "🥈 BẠC"
                                    : reward.rewardType === "BRONZE"
                                      ? "🥉 ĐỒNG"
                                      : "🎊 PHÚC"}
                              </span>
                            </td>
                            <td className="px-3 py-2 text-gray-700">
                              {reward.rewardContent}
                            </td>
                            {/* <td className="px-3 py-2 text-center text-blue-600 font-bold">
                              #{reward.wateringTurnNumber}
                            </td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div className="p-8 text-center text-gray-500">
                      Chưa có phần thưởng
                    </div>
                  )}
                  {rewardsPagination && rewardsPagination.totalPages > 1 && (
                    <div className="bg-gray-100 px-4 py-3 flex justify-between items-center">
                      <span className="text-gray-600 font-bold">
                        Trang {rewardsPagination.page}/
                        {rewardsPagination.totalPages}
                      </span>
                      <div className="flex gap-2">
                        <button
                          onClick={() =>
                            fetchUserRewards(
                              rewardsPagination.page - 1,
                              rewardsPagination.limit,
                            )
                          }
                          disabled={rewardsPagination.page === 1}
                          className="px-3 py-1 bg-orange-400 text-yellow-400 rounded disabled:opacity-50 font-bold hover:bg-orange-500"
                        >
                          ← Trước
                        </button>
                        <button
                          onClick={() =>
                            fetchUserRewards(
                              rewardsPagination.page + 1,
                              rewardsPagination.limit,
                            )
                          }
                          disabled={
                            rewardsPagination.page ===
                            rewardsPagination.totalPages
                          }
                          className="px-3 py-1 bg-orange-400 text-yellow-400 rounded disabled:opacity-50 font-bold hover:bg-orange-500"
                        >
                          Sau →
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* BẢNG DANH SÁCH BÀI DỰ THI */}
              <div className="bg-orange-50/95 rounded-lg p-6 border-4 border-[#ff8f40] shadow-xl">
                <h2 className="text-2xl font-bold text-[#ff8f40] text-center mb-4">
                  📋 LỊCH SỬ BÀI DỰ THI 📋
                </h2>
                <div className="bg-white rounded-lg overflow-hidden max-h-96 overflow-y-auto">
                  {submissionLoading ? (
                    <div className="p-4 text-center text-gray-500">
                      Đang tải...
                    </div>
                  ) : submissions && submissions.length > 0 ? (
                    <table className="w-full text-sm">
                      <thead className="bg-orange-400 text-yellow-400 sticky top-0">
                        <tr>
                          <th className="px-3 py-3 text-left font-bold">
                            Link
                          </th>
                          <th className="px-3 py-3 text-center font-bold">
                            Trạng thái
                          </th>
                          <th className="px-3 py-3 text-center font-bold">
                            Ngày
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {submissions.map((submission, index) => (
                          <tr
                            key={submission.id}
                            className={
                              index % 2 === 0 ? "bg-white" : "bg-gray-50"
                            }
                          >
                            <td className="px-3 py-2 text-xs">
                              <a
                                href={submission.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 hover:underline truncate block max-w-[200px]"
                              >
                                {submission.link}
                              </a>
                            </td>
                            <td className="px-3 py-2 text-center">
                              <span
                                className={`inline-block px-2 py-1 rounded text-xs font-bold ${
                                  submission.status === "approved"
                                    ? "bg-green-500 text-white"
                                    : submission.status === "pending"
                                      ? "bg-yellow-400 text-white"
                                      : "bg-red-500 text-white"
                                }`}
                              >
                                {submission.status === "approved"
                                  ? "✓ Đã duyệt"
                                  : submission.status === "pending"
                                    ? "⏳ Chờ duyệt"
                                    : "✗ Từ chối"}
                              </span>
                            </td>
                            <td className="px-3 py-2 text-center text-gray-600 text-xs">
                              {new Date(
                                submission.createdAt,
                              ).toLocaleDateString("vi-VN")}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div className="p-8 text-center text-gray-500">
                      Chưa có submission
                    </div>
                  )}
                  {submissionPagination &&
                    submissionPagination.totalPages > 1 && (
                      <div className="bg-gray-100 px-4 py-3 flex justify-between items-center">
                        <span className="text-gray-600 font-bold">
                          Trang {submissionPagination.page}/
                          {submissionPagination.totalPages}
                        </span>
                        <div className="flex gap-2">
                          <button
                            onClick={() =>
                              fetchSubmissions(
                                submissionPagination.page - 1,
                                submissionPagination.limit,
                              )
                            }
                            disabled={submissionPagination.page === 1}
                            className="px-3 py-1 bg-orange-400 text-yellow-400 rounded disabled:opacity-50 font-bold hover:bg-orange-500"
                          >
                            ← Trước
                          </button>
                          <button
                            onClick={() =>
                              fetchSubmissions(
                                submissionPagination.page + 1,
                                submissionPagination.limit,
                              )
                            }
                            disabled={
                              submissionPagination.page ===
                              submissionPagination.totalPages
                            }
                            className="px-3 py-1 bg-orange-400 text-yellow-400 rounded disabled:opacity-50 font-bold hover:bg-orange-500"
                          >
                            Sau →
                          </button>
                        </div>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <img src={developedBy} alt="Developed By" />
      </div>
      {/* <Footer></Footer> */}
    </>
  );
};

export default EventTet2026;
